import type { LucideIcon } from "lucide-react";
import {
  FileText,
  Tags,
  Bot,
  Palette,
  QrCode,
  KeyRound,
  Repeat,
  Braces,
  ArrowRightLeft,
  Calculator,
  Pipette,
  Regex,
  Clock,
  Type,
  TextCursorInput,
  Binary,
  Sparkles,
  PenTool,
  Hash,
  CaseSensitive,
  FileImage,
} from "lucide-react";

export type Tool = {
  slug: string;
  i18nKey: string;
  Icon: LucideIcon;
  hidden?: boolean;
};

export const tools: Tool[] = [
  { slug: "password-generator", i18nKey: "toolList.password", Icon: KeyRound },
  { slug: "qr-code-generator", i18nKey: "toolList.qr", Icon: QrCode },
  {
    slug: "business-name-generator",
    i18nKey: "toolList.businessName",
    Icon: Sparkles,
  },
  {
    slug: "free-logo-creator",
    i18nKey: "toolList.logoCreator",
    Icon: PenTool,
  },
  { slug: "json-formatter", i18nKey: "toolList.json", Icon: Braces },
  { slug: "json-to-toon", i18nKey: "toolList.toon", Icon: ArrowRightLeft },
  {
    slug: "color-palette-generator",
    i18nKey: "toolList.palette",
    Icon: Palette,
  },
  {
    slug: "sitemap-generator",
    i18nKey: "toolList.sitemap",
    Icon: FileText,
  },
  {
    slug: "meta-tag-generator",
    i18nKey: "toolList.meta",
    Icon: Tags,
    hidden: true,
  },
  {
    slug: "robots-txt-generator",
    i18nKey: "toolList.robots",
    Icon: Bot,
  },
  {
    slug: "redirects-tester",
    i18nKey: "toolList.redirects",
    Icon: Repeat,
  },
  {
    slug: "compound-calculator",
    i18nKey: "toolList.compound",
    Icon: Calculator,
  },
  {
    slug: "color-converter",
    i18nKey: "toolList.colorConverter",
    Icon: Pipette,
  },
  {
    slug: "color-inverter",
    i18nKey: "toolList.colorInverter",
    Icon: ArrowRightLeft,
  },
  {
    slug: "regex-tester",
    i18nKey: "toolList.regex",
    Icon: Regex,
  },
  {
    slug: "time-zone-converter",
    i18nKey: "toolList.timezone",
    Icon: Clock,
  },
  {
    slug: "word-counter",
    i18nKey: "toolList.wordCounter",
    Icon: Type,
  },
  {
    slug: "lorem-ipsum-generator",
    i18nKey: "toolList.loremIpsum",
    Icon: TextCursorInput,
  },
  {
    slug: "base64-encoder",
    i18nKey: "toolList.base64",
    Icon: Binary,
  },
  {
    slug: "uuid-generator",
    i18nKey: "toolList.uuid",
    Icon: Hash,
  },
  {
    slug: "hexagon-drag-and-drop",
    i18nKey: "toolList.hexagonDragAndDrop",
    Icon: Braces,
  },
  {
    slug: "text-case-converter",
    i18nKey: "toolList.textCaseConverter",
    Icon: CaseSensitive,
  },
  {
    slug: "image-to-pdf",
    i18nKey: "toolList.imageToPdf",
    Icon: FileImage,
  },

  // Next Tools:

  // Track Habbits

  // ASCII Art Generator
  // Generate ASCII art from text or image.

  // HTTP Status Code Checker
  // Enter a URL and get the HTTP response code + explanation (200 OK, 404 Not Found, 500 etc.).`

  // Image to ASCII Art Converter
  // Convert an image to ASCII art.

  // Image to Text Converter
  // Convert an image to text.

  // Image to PNG Converter
  // Convert an image to PNG.

  // Image to JPG Converter
  // Convert an image to JPG.

  // Image to GIF Converter
  // Convert an image to GIF.

  // Image to SVG Converter
  // Convert an image to SVG.

  // Image to WebP Converter
  // Convert an image to WebP.
];

export const visibleTools = tools.filter((t) => !t.hidden);
export const homepageTools = visibleTools;
